import React, { useEffect, useState } from 'react';
import logo from '../images/haqdarshak-logo.png';
import { Link, useLocation, useNavigate } from "react-router-dom";
import { getSession } from "../utils/session";

const KPIHeader = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [roleId, setRoleId] = useState(null);

  // Get role from session
  useEffect(() => {
    const session = getSession();
    if (session?.roleId) setRoleId(session.roleId);
  }, []);

  const handleLogout = () => {
    sessionStorage.clear();
    navigate("/");
  };

  const highlightKPI =
    location.pathname === "/Project-Level" ||
    location.pathname === "/Project-KPI-Comparison" ||
    location.pathname === "/Project-Scheme-Diversity";

  const highlightMilestone =
    location.pathname === "/Project-Milestone-Summary";

  return (
    <div className="fixed flex flex-row h-14 top-0 left-0 w-full bg-white text-black font-extrabold shadow-sm shadow-black z-50 items-center px-4">
      <div className="flex items-center">

        {/* Logo */}
        <div className="flex">
          <img src={logo} alt="Logo" className="h-10 w-auto" />
          <h1 className="ml-[3vw] text-2xl font-bold tracking-wide text-black flex items-center">
            PROJECT360 Dashboard
          </h1>
        </div>

        {/* MENU */}
        <div className="ml-5 flex flex-row gap-2 text-md font-semibold flex-grow">
          <Link
            to="/Project-Summary"
            className={`py-1 px-2 rounded-lg hover:text-pink-800 ${
              location.pathname === "/Project-Summary" ? "bg-pink-100 text-pink-800 border-2 border-pink-800" : ""
            }`}
          >
            Project Summary
          </Link>

          <Link
            to="/Project-Level"
            className={`py-1 px-2 rounded-lg hover:text-pink-800 ${
              highlightKPI ? "bg-pink-100 text-pink-800 border-2 border-pink-800" : ""
            }`}
          >
            Project KPI
          </Link>

          {/* HIDE FOR ROLE 28 */}
          {roleId !== 28 && (
            <Link
              to="/Project-Milestone-Summary"
              className={`py-1 px-2 rounded-lg hover:text-pink-800 ${
                highlightMilestone ? "bg-pink-100 text-pink-800 border-2 border-pink-800" : ""
              }`}
            >
              Project Milestone
            </Link>
          )}

          
        </div>

        {/* LOGOUT */}
        <button
          onClick={handleLogout}
          className="ml-[20vw] bg-red-600 text-white px-4 py-1 rounded-lg hover:bg-red-700 transition"
        >
          Logout
        </button>
      </div>
    </div>
  );
};

export default KPIHeader;